"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BadgePosition = exports.InventoryPolicy = exports.ProductTierType = exports.ProductComponentPriceType = exports.ProductType = exports.ProductClassification = void 0;
var api_service_1 = require("./api-service");
var CatalogService = /** @class */ (function (_super) {
    __extends(CatalogService, _super);
    function CatalogService() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.endpoint = 'catalog';
        return _this;
    }
    CatalogService.prototype.products = function (params) {
        return this.getCollectionRequest(this.url('products'), {
            params: params,
        });
    };
    CatalogService.prototype.yieldProducts = function (params) {
        return this.api.client
            .get(this.url('products'), { params: params })
            .then(function (res) { return Promise.resolve(res.data.data); });
    };
    CatalogService.prototype.bulkGetProducts = function (ids, include) {
        if (include === void 0) { include = []; }
        return this.products({ filter: { id: ids }, include: include, perPage: -1 }).then(function (res) { return res.data; });
    };
    CatalogService.prototype.productsSearch = function (params) {
        return this.getCollectionRequest(this.url('products', 'search'), {
            params: params,
        });
    };
    CatalogService.prototype.yieldProductsSearch = function (params) {
        return this.api.client
            .get(this.url('products', 'search'), { params: params })
            .then(function (res) { return Promise.resolve(res.data.data); });
    };
    CatalogService.prototype.getProduct = function (id) {
        return this.getRequest(this.url('products', id));
    };
    CatalogService.prototype.createProduct = function (product) {
        return this.postRequest(this.url('products'), product);
    };
    CatalogService.prototype.reindexProducts = function () {
        return this.postRequest(this.url('products', 'reindex'));
    };
    CatalogService.prototype.updateProduct = function (id, product) {
        return this.putRequest(this.url('products', id), product);
    };
    CatalogService.prototype.deleteProduct = function (id) {
        return this.deleteRequest(this.url('products', id));
    };
    CatalogService.prototype.massDeleteProducts = function (data) {
        return this.deleteRequest(this.url('products'), { data: data });
    };
    CatalogService.prototype.exportProducts = function (data) {
        if (data === void 0) { data = {}; }
        return this.postRequest(this.url('products', 'export'), data);
    };
    CatalogService.prototype.deductProduct = function (id, data) {
        return this.patchRequest(this.url('products', id, 'deduct'), data);
    };
    CatalogService.prototype.restockProduct = function (id, data) {
        return this.patchRequest(this.url('products', id, 'restock'), data);
    };
    CatalogService.prototype.productImages = function (id) {
        return this.getRequest(this.url('products', id, 'images'));
    };
    CatalogService.prototype.getProductImage = function (productId, imageId) {
        return this.getRequest(this.url('products', productId, 'images', imageId));
    };
    CatalogService.prototype.createProductImage = function (productId, image) {
        return this.postRequest(this.url('products', productId, 'images'), image);
    };
    CatalogService.prototype.updateProductImage = function (productId, imageId, image) {
        return this.putRequest(this.url('products', productId, 'images', imageId), image);
    };
    CatalogService.prototype.deleteProductImage = function (productId, imageId) {
        return this.deleteRequest(this.url('products', productId, 'images', imageId));
    };
    CatalogService.prototype.productRelated = function (id, params) {
        return this.getCollectionRequest(this.url('products', id, 'related'), {
            params: params,
        });
    };
    CatalogService.prototype.generateProductVariant = function (id, data) {
        return this.postRequest(this.url('products', id, 'variants'), data);
    };
    CatalogService.prototype.updateProductVariant = function (id, data) {
        return this.putRequest(this.url('products', id, 'variants'), data);
    };
    CatalogService.prototype.updateProductVariantAttributes = function (id, data) {
        return this.putRequest(this.url('products', id, 'variants', 'attributes'), data);
    };
    CatalogService.prototype.deleteProductVariants = function (id, data) {
        return this.deleteRequest(this.url('products', id, 'variants'), { data: data });
    };
    CatalogService.prototype.importProducts = function (data) {
        return this.postRequest(this.url('products', 'import'), data, {
            headers: {
                'Content-Type': 'multipart/form-type',
            },
        });
    };
    //Taxonomy
    CatalogService.prototype.taxonomies = function (params) {
        return this.getCollectionRequest(this.url('taxonomy'), {
            params: params,
        });
    };
    CatalogService.prototype.bulkGetTaxonomies = function (ids) {
        return this.taxonomies({ filter: { id: ids }, perPage: -1 }).then(function (res) { return res.data; });
    };
    CatalogService.prototype.createTaxonomy = function (taxonomy) {
        return this.postRequest(this.url('taxonomy'), taxonomy);
    };
    CatalogService.prototype.getTaxonomy = function (id) {
        return this.getRequest(this.url('taxonomy', id));
    };
    CatalogService.prototype.updateTaxonomy = function (id, taxonomy) {
        return this.putRequest(this.url('taxonomy', id), taxonomy);
    };
    CatalogService.prototype.deleteTaxonomy = function (id) {
        return this.deleteRequest(this.url('taxonomy', id));
    };
    CatalogService.prototype.massDeleteTaxonomy = function (data) {
        return this.deleteRequest(this.url('taxonomy'), { data: data });
    };
    // Categories
    CatalogService.prototype.categories = function (params) {
        return this.getCollectionRequest(this.url('categories'), {
            params: params,
        });
    };
    CatalogService.prototype.getCategory = function (idOrSlug) {
        return this.getRequest(this.url('categories', idOrSlug));
    };
    CatalogService.prototype.createCategory = function (category) {
        return this.postRequest(this.url('categories'), category);
    };
    CatalogService.prototype.updateCategory = function (id, category) {
        return this.putRequest(this.url('categories', id), category);
    };
    CatalogService.prototype.deleteCategory = function (id) {
        return this.deleteRequest(this.url('categories', id));
    };
    CatalogService.prototype.massDeleteCategories = function (data) {
        return this.deleteRequest(this.url('categories'), { data: data });
    };
    // Brands
    CatalogService.prototype.brands = function (params) {
        return this.getCollectionRequest(this.url('brands'), {
            params: params,
        });
    };
    CatalogService.prototype.getBrand = function (idOrSlug, params) {
        return this.getRequest(this.url('brands', idOrSlug), { params: params });
    };
    CatalogService.prototype.createBrand = function (brand) {
        return this.postRequest(this.url('brands'), brand);
    };
    CatalogService.prototype.updateBrand = function (id, brand) {
        return this.putRequest(this.url('brands', id), brand);
    };
    CatalogService.prototype.deleteBrand = function (id) {
        return this.deleteRequest(this.url('brands', id));
    };
    CatalogService.prototype.massDeleteBrands = function (data) {
        return this.deleteRequest(this.url('brands'), { data: data });
    };
    // Tags
    CatalogService.prototype.tags = function (params) {
        return this.getCollectionRequest(this.url('tags'), {
            params: params,
        });
    };
    CatalogService.prototype.getTag = function (idOrName) {
        return this.getRequest(this.url('tags', idOrName));
    };
    CatalogService.prototype.createTag = function (brand) {
        return this.postRequest(this.url('tags'), brand);
    };
    CatalogService.prototype.updateTag = function (id, tag) {
        return this.putRequest(this.url('tags', id), tag);
    };
    CatalogService.prototype.deleteTag = function (id) {
        return this.deleteRequest(this.url('tags', id));
    };
    CatalogService.prototype.massDeleteTags = function (data) {
        return this.deleteRequest(this.url('tags'), { data: data });
    };
    // Badges
    CatalogService.prototype.badges = function (params) {
        return this.getCollectionRequest(this.url('badges'), {
            params: params,
        });
    };
    CatalogService.prototype.getBadge = function (idOrCode) {
        return this.getRequest(this.url('badges', idOrCode));
    };
    CatalogService.prototype.createBadge = function (brand) {
        return this.postRequest(this.url('badges'), brand);
    };
    CatalogService.prototype.updateBadge = function (id, tag) {
        return this.putRequest(this.url('badges', id), tag);
    };
    CatalogService.prototype.deleteBadge = function (id) {
        return this.deleteRequest(this.url('badges', id));
    };
    CatalogService.prototype.massDeleteBadges = function (data) {
        return this.deleteRequest(this.url('badges'), { data: data });
    };
    return CatalogService;
}(api_service_1.ApiService));
exports.default = CatalogService;
var ProductClassification;
(function (ProductClassification) {
    ProductClassification["BUNDLE"] = "bundle";
    ProductClassification["COMMON"] = "common";
})(ProductClassification = exports.ProductClassification || (exports.ProductClassification = {}));
var ProductType;
(function (ProductType) {
    ProductType["DIGITAL"] = "digital";
    ProductType["PHYSICAL"] = "physical";
    ProductType["VIRTUAL"] = "virtual";
})(ProductType = exports.ProductType || (exports.ProductType = {}));
var ProductComponentPriceType;
(function (ProductComponentPriceType) {
    ProductComponentPriceType["DYNAMIC"] = "dynamic";
    ProductComponentPriceType["FIXED"] = "fixed";
    ProductComponentPriceType["NONE"] = "none";
})(ProductComponentPriceType = exports.ProductComponentPriceType || (exports.ProductComponentPriceType = {}));
var ProductTierType;
(function (ProductTierType) {
    ProductTierType["PERCENTAGE"] = "percentage";
    ProductTierType["FIXED"] = "fixed";
})(ProductTierType = exports.ProductTierType || (exports.ProductTierType = {}));
var InventoryPolicy;
(function (InventoryPolicy) {
    InventoryPolicy["CONTINUE"] = "continue";
    InventoryPolicy["STOP"] = "stop";
})(InventoryPolicy = exports.InventoryPolicy || (exports.InventoryPolicy = {}));
var BadgePosition;
(function (BadgePosition) {
    BadgePosition["TOP_LEFT"] = "top_left";
    BadgePosition["TOP_RIGHT"] = "top_right";
    BadgePosition["BOTTOM_LEFT"] = "bottom_left";
    BadgePosition["BOTTOM_RIGHT"] = "bottom_right";
    BadgePosition["LEFT_CENTER"] = "left_center";
    BadgePosition["CENTER_CENTER"] = "center_center";
    BadgePosition["RIGHT_CENTER"] = "right_center";
    BadgePosition["TOP_CENTER"] = "top_center";
    BadgePosition["BOTTOM_CENTER"] = "bottom_center";
})(BadgePosition = exports.BadgePosition || (exports.BadgePosition = {}));
//# sourceMappingURL=catalog-service.js.map